export default "__VITE_ASSET__BK9itmpT__"